/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-syntax */

// This is for checking if the data has been fetched and also for handling hiding the loader
let dataAvailable = false;
const accountBalance = {};
let accountHasInvoiceTerms;
let arType;
// eslint-disable-next-line no-unused-vars
let balancePayments;
let billingType;
let currency;
let hasPaymentMethods;
let invoiceTermsEnabled;
let jobs;
let accountNumber;
let phone;

const isOverview = document.body.classList.contains('ex-account-balances');
const isInvoices = document.body.classList.contains('ex-invoices');
const isStatements = document.body.classList.contains('ex-statements');
const isAccountOverview = isOverview || isInvoices || isStatements;

if (isAccountOverview) {
  accountNumber = EvoXLayer().user.account_number;
  phone = EvoXLayer().user.phone;
}

// Function to find the value of a key by its label in a nested object
function findValueByLabel(obj, searchLabel) {
  if (typeof obj !== 'object' || obj === null) {
    return null;
  }

  for (const [key, value] of Object.entries(obj)) {
    // Check if the current object contains the matching label
    if (key === 'label' && value === searchLabel) {
      return obj.value || null; // Return the value of the 'value' key if it exists
    }

    // If the value is an object or array, search recursively
    if (typeof value === 'object') {
      const result = findValueByLabel(value, searchLabel);
      if (result !== null) {
        return result;
      }
    }
  }

  return null; // Return null if no match is found
}

// Format argument so it is always a number with 2 decimal places, commas and a currency symbol
function formatCurrency(value) {
  if (value === null || Number.isNaN(value)) return `${currency}0.00`;
  return `${currency}${parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

function getData() {
  $.ajax({
    type: 'get',
    url: '/customer/account-overview',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
    success(response) {
      accountHasInvoiceTerms = response.data.accountHasInvoiceTerms;
      arType = response.data.arType;
      balancePayments = response.data.balancePayments;
      billingType = response.data.billingType;
      currency = response.data.currency;
      hasPaymentMethods = response.data.hasPaymentMethods;
      invoiceTermsEnabled = response.data.invoiceTermsEnabled;
      jobs = response.data.jobs;

      console.log(response.data);

      // Creating object with only the data we need for the widget
      Object.keys(response.data.accountBalance).forEach((key) => {
        const currentKey = response.data.accountBalance[key];

        const creditLimit = findValueByLabel(currentKey, 'Credit Limit');
        const creditAvailable = findValueByLabel(currentKey, 'Credit Available');
        const due = findValueByLabel(currentKey, 'Due Now');
        const credits = findValueByLabel(currentKey, '- Credits');
        const financeCharges = findValueByLabel(currentKey, '+ Finance Charges');
        const total = findValueByLabel(currentKey, 'Total');
        const { address } = currentKey.table3;
        const { table2 } = currentKey;

        accountBalance[key] = {
          creditLimit,
          creditAvailable,
          due,
          credits,
          financeCharges,
          total,
          address,
          table2,
        };
      });

      dataAvailable = true;
      setTimeout(() => {
        document.querySelector('.account-overview-widget').classList.add('loaded');
      }, 500);
    },
    error(error) {
      console.log(error);
    },
  });
}

function createAccountOverviewWidget() {
  const accountOverviewWidget = document.createElement('div');
  accountOverviewWidget.classList.add('account-overview-widget-wrapper');
  accountOverviewWidget.innerHTML = `
  <div class="container">
    <div class="account-overview-widget">
      <div class="account-overview-widget__loader"></div>
      <div class="account-overview-widget__content">
        <div class="account-selection">

        </div>
        <div class="billing-details account-overview-widget--card">
          <h2>Billing Details</h2>
          <div class="billing-details__address">
            <h5>Address</h5>
          </div>
          <div class="billing-details__phone">
            <h5>Phone Number</h5>
          </div>
        </div>
        <div class="account-credit account-overview-widget--card">
          <h2>Account Credit</h2>
          <div class="account-credit__limit">
            <h5>Limit</h5>
          </div>
          <div class="account-credit__available">
            <h5>Available</h5>
          </div>
        </div>

        <div class="account-balance account-overview-widget--card">
          <div class="account-balance__left">
            <h2>Account Balance</h2>
            <div class="account-balance__outstanding">
              <h5>Due Now</h5>
            </div>
          </div>
          <div class="account-balance__right">
            <div class="account-balance__totaldue">
              <h5>Total</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `;

  return accountOverviewWidget;
}

function populateAccountSelection() {
  const accountSelection = document.querySelector('.account-selection');
  const selectElement = document.createElement('select');
  selectElement.name = 'accountSummarySelect';
  selectElement.classList.add('account-summary-select');
  selectElement.required = true;

  selectElement.addEventListener('change', function () {
    const selectedKey = this.options[this.selectedIndex].dataset.key;
    updateAccountOverviewWidget(selectedKey);

    // eslint-disable-next-line no-undef
    setAccountSummaryTable(this);
  });

  // Add the default option
  const defaultOption = document.createElement('option');
  defaultOption.value = 'account_AccountSummary';
  defaultOption.dataset.key = 'AccountSummary';
  defaultOption.selected = true;
  defaultOption.textContent = 'Account Consolidated';
  selectElement.appendChild(defaultOption);

  if (billingType) {
    // Add options dynamically based on jobs
    jobs.forEach((job) => {
      const option = document.createElement('option');
      option.value = `account_${job.job}`;
      option.dataset.key = job.job;
      option.textContent = job.name;
      selectElement.appendChild(option);
    });
  } else {
    selectElement.disabled = true; // Disable the select element if billingType is not set
    selectElement.style.appearance = 'none'; // Hide the dropdown arrow
  }

  // Append the select element to the account-selection div
  accountSelection.appendChild(selectElement);

  // Add account number
  const accountNumberDiv = document.createElement('div');
  accountNumberDiv.classList.add('account-number');
  accountNumberDiv.innerHTML = `ID ${accountNumber}`;
  accountSelection.appendChild(accountNumberDiv);
}

function updateAccountOverviewWidget(key) {
  // update the data in the widget based on the key and corresponding data in accountBalance
  const accountBalanceData = accountBalance[key];

  let canSeePaymentButton = false;
  if (key === 'AccountSummary') {
    canSeePaymentButton = !billingType && (hasPaymentMethods || (jobs[0] && jobs[0].hasCardsOnFile));
  } else {
    canSeePaymentButton = hasPaymentMethods || (jobs[key] && jobs[key].hasCardsOnFile);
  }

  // Add / Update button and link to the account selection
  const accountSelection = document.querySelector('.account-selection');
  const accountSelectionButtons = document.createElement('div');
  accountSelectionButtons.classList.add('account-selection__buttons');

  if (key === 'AccountSummary') {
    accountSelectionButtons.insertAdjacentHTML('afterbegin', `
    <a href="/customer/current-statement/" class="btn-custom primary" target="_blank">Generate Current Statement</a>
    `);
  } else {
    accountSelectionButtons.insertAdjacentHTML('afterbegin', `
    <a href="/customer/current-statement/${key}" class="btn-custom primary" target="_blank">Generate Current Statement</a>
    `);
  }

  if (isInvoices || isStatements) {
    accountSelectionButtons.insertAdjacentHTML('beforeend', `
    <a href="/customer/account-overview">See Account Overview<i class="fa fa-chevron-right"></i></a>
    `);
  }

  if (document.querySelector('.account-selection__buttons')) {
    document.querySelector('.account-selection__buttons').remove();
  }
  accountSelection.appendChild(accountSelectionButtons);

  // Update the billing details
  const billingDetailsAddress = document.querySelector('.billing-details__address');
  billingDetailsAddress.innerHTML = `<h5>Address</h5>${accountBalanceData.address
    .filter((item) => item.label) // Filter out items with empty labels
    .map((item) => `<p>${item.label}</p>`) // Wrap each label in a p tag
    .join('')}`; // Combine all p tags into a single string

  const billingDetailsPhone = document.querySelector('.billing-details__phone');
  billingDetailsPhone.innerHTML = `<h5>Phone Number</h5>${phone}`; // Add phone number

  // Update the account credit
  const accountCreditLimit = document.querySelector('.account-credit__limit');
  accountCreditLimit.innerHTML = `<h5>Limit</h5> <span class="highlighted-currency">${formatCurrency(accountBalanceData.creditLimit)}</span>`;

  const accountCreditAvailable = document.querySelector('.account-credit__available');
  accountCreditAvailable.innerHTML = `<h5>Available</h5> <span class="highlighted-currency">${formatCurrency(accountBalanceData.creditAvailable)}</span>`;

  // Update the account balance
  const accountBalanceOutstanding = document.querySelector('.account-balance__outstanding');
  accountBalanceOutstanding.innerHTML = `
    <h5>Due Now</h5>
    <span class="highlighted-currency">${formatCurrency(accountBalanceData.due)}</span>
    <p class="account-balance__outstanding--credits">
      <span>Credits & Discounts</span><br>
      - ${formatCurrency(accountBalanceData.credits)}
    </p>
    <p class="account-balance__outstanding--finance-charges">
      <span>Finance & New Charges</span><br>
      + ${formatCurrency(accountBalanceData.financeCharges)}
    </p>`;

  const accountBalanceTotalDue = document.querySelector('.account-balance__totaldue');
  accountBalanceTotalDue.innerHTML = `<h5>Total</h5> ${formatCurrency(accountBalanceData.total)}`;

  const accountBalanceRight = document.querySelector('.account-balance__right');

  // Add / Update payment selection
  // Add payment form and options if invoice terms are enabled
  if (invoiceTermsEnabled) {
    // Remove existing elements if they already exist
    const existingPaymentForm = document.querySelector('.account-overview-widget .accountpayment-form');
    const existingPaymentOptionsWrapper = document.querySelector('.account-overview-widget .account-balance-select-wrapper');
    const existingCustomAmountWrapper = document.querySelector('.account-overview-widget .custom-amount-wrapper');

    if (existingPaymentForm) existingPaymentForm.remove();
    if (existingPaymentOptionsWrapper) existingPaymentOptionsWrapper.remove();
    if (existingCustomAmountWrapper) existingCustomAmountWrapper.remove();

    const paymentForm = document.createElement('form');
    paymentForm.id = `accountpayment-form-${key}`;
    paymentForm.classList.add('accountpayment-form');
    paymentForm.method = 'POST';
    paymentForm.action = '/customer/invoices/pay/now';
    paymentForm.innerHTML = `
      <input type="hidden" name="_token" value="${$('meta[name="csrf-token"]').attr('content')}">
      <input type="hidden" name="job" value="${key !== 'AccountSummary' ? key : 0}">
      <input type="hidden" name="outstandingBalance" value="0">
      <input type="hidden" name="accountBalancePayment" value="true">
      <input type="hidden" name="accountBalancePaymentType" value="outstanding_amount">
      <input type="hidden" name="outstandingBalanceMetadata" value="">
    `;

    const paymentOptionsWrapper = document.createElement('div');
    paymentOptionsWrapper.classList.add('account-balance-select-wrapper');
    if (key === 'AccountSummary' && billingType) {
      paymentOptionsWrapper.classList.add('hide');
    }
    paymentOptionsWrapper.innerHTML = `
      <h5>Select what you want to pay</h5>
      <select name="accountBalanceSelectPaymentType" class="account-balance-select" data-account-key="${key}" onchange="changeAccountBalancePaymentType(event, '${key}')">
        <option value="outstanding_amount">Outstanding Amount</option>
        ${!accountHasInvoiceTerms ? '<option value="last_statement">Last Statement</option>' : ''}
        ${arType === 1 ? '<option value="select_invoices">Select Invoices</option>' : '<option value="custom_amount">Custom Amount</option>'}
      </select>
    `;

    const customAmountWrapper = document.createElement('div');
    customAmountWrapper.classList.add('custom-amount-wrapper');
    if (key === 'AccountSummary') {
      customAmountWrapper.classList.add('hide');
    }
    customAmountWrapper.innerHTML = `
      <table class="table" width="100%">
        <tbody>
          <tr class="balance-current">
            <td class="title price-title">Custom Amount</td>
            <td class="value price-value">
              <div class="account-payment-input-wrapper">
                <span>${currency}</span><input type="number" id="custom-amount-${key}" class="form-control" name="custom_amount_value" onfocusout="buildAccountPaymentCustomAmount(this, '${key}')" value="0.00" step=".01">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    `;

    accountBalanceRight.insertAdjacentElement('beforeend', paymentForm);
    accountBalanceRight.insertAdjacentElement('beforeend', paymentOptionsWrapper);
    accountBalanceRight.insertAdjacentElement('beforeend', customAmountWrapper);
  }

  // add table with info
  // Remove existing tableWrapper if it already exists
  const existingTableWrapper = document.querySelector('.table-account-overview-wrapper');
  if (existingTableWrapper) existingTableWrapper.remove();

  const tableWrapper = document.createElement('div');
  tableWrapper.classList.add('table-account-overview-wrapper');

  const table = document.createElement('table');
  table.classList.add('table', 'table-account-overview', 'table-account-overview-table-2');
  table.setAttribute('data-account-key', key);
  table.setAttribute('width', '100%');

  const tbody = document.createElement('tbody');

  accountBalanceData.table2.forEach((section, sectionIndex) => {
    section.forEach((item) => {
      if (item.label) {
        const tr = document.createElement('tr');
        tr.classList.add(
          'balance-current',

        );

        if (item.label === 'Total' && item.metadata) {
          tr.id = `table-account-overview-total-${key}`;
          tr.dataset.metadata = JSON.stringify(item.metadata);
        }

        const tdTitle = document.createElement('td');
        tdTitle.classList.add('title', 'price-title');
        if (item.class) {
          item.class.split(' ').forEach((className) => {
            if (className.trim()) {
              tdTitle.classList.add(className);
            }
          });
        }
        tdTitle.textContent = item.label;

        const tdValue = document.createElement('td');
        tdValue.classList.add('value', 'price-value');
        if (item.class) {
          item.class.split(' ').forEach((className) => {
            if (className.trim()) {
              tdValue.classList.add(className);
            }
          });
        }
        tdValue.textContent = formatCurrency(item.value);

        tr.appendChild(tdTitle);
        tr.appendChild(tdValue);
        tbody.appendChild(tr);
      }
    });

    if (sectionIndex < accountBalanceData.table2.length - 1) {
      const emptyRow = document.createElement('tr');
      emptyRow.classList.add(
        'table-account-overview-underline-white',
        'table-account-overview-empty-row',
      );
      const emptyTd = document.createElement('td');
      emptyRow.appendChild(emptyTd);
      tbody.appendChild(emptyRow);
    }
  });

  table.appendChild(tbody);
  tableWrapper.appendChild(table);
  accountBalanceRight.insertAdjacentElement('beforeend', tableWrapper);

  // Remove existing payment elements
  function removeExistingPaymentElements() {
    const existingMakePaymentDiv = document.querySelector('.make-payment');
    const existingSelectInvoicesDiv = document.querySelector('.select-invoices');
    const existingDiscountsLabelDiv = document.querySelector('.discounts-not-applied-label');

    if (existingMakePaymentDiv) existingMakePaymentDiv.remove();
    if (existingSelectInvoicesDiv) existingSelectInvoicesDiv.remove();
    if (existingDiscountsLabelDiv) existingDiscountsLabelDiv.remove();
  }

  // Add payment button
  if (canSeePaymentButton) {
    if (invoiceTermsEnabled) {
      removeExistingPaymentElements();

      const makePaymentDiv = document.createElement('div');
      makePaymentDiv.classList.add('mb-10', 'make-payment');
      makePaymentDiv.id = `make-payment-${key}`;
      makePaymentDiv.innerHTML = `
        <a href="javascript:;" onclick="submitInvoiceTermsPayment('${key}')" class="btn-custom primary">Make Payment</a>
      `;

      const selectInvoicesDiv = document.createElement('div');
      selectInvoicesDiv.classList.add('col-xs-12', 'mb-10', 'select-invoices');
      const filters = encodeURIComponent(JSON.stringify({ job: key }));
      selectInvoicesDiv.innerHTML = `
        <a href="/customer/invoices?filters=${filters}" class="btn-custom primary">Select Invoices</a>
      `;

      const discountsLabelDiv = document.createElement('div');
      discountsLabelDiv.classList.add('col-xs-12', 'mb-10', 'text-center', 'discounts-not-applied-label');
      discountsLabelDiv.innerHTML = `
        <small class="bolder">Discounts may not apply</small>
      `;

      accountBalanceRight.insertAdjacentElement('beforeend', makePaymentDiv);
      accountBalanceRight.insertAdjacentElement('beforeend', selectInvoicesDiv);
      accountBalanceRight.insertAdjacentElement('beforeend', discountsLabelDiv);
    } else if (balancePayments) {
      removeExistingPaymentElements();

      const makePaymentDiv = document.createElement('div');
      makePaymentDiv.classList.add('mb-10', 'make-payment');
      makePaymentDiv.innerHTML = `
        <a href="/customer/account-payment/${billingType ? key : 0}" class="btn-custom primary">Make Payment</a>
      `;
      accountBalanceRight.insertAdjacentElement('beforeend', makePaymentDiv);
    } else {
      removeExistingPaymentElements();

      const makePaymentDiv = document.createElement('div');
      makePaymentDiv.classList.add('mb-10', 'make-payment');
      makePaymentDiv.innerHTML = `
        <a href="/customer/invoices" class="btn-custom primary">Make Payment</a>
      `;
      accountBalanceRight.insertAdjacentElement('beforeend', makePaymentDiv);
    }
  } else {
    removeExistingPaymentElements();
  }
}

function checkDataAvailability(startTime) {
  if (!dataAvailable) {
    if (Date.now() - startTime < 10000) {
      // Retry after 500ms if less than 10 seconds have passed
      setTimeout(() => checkDataAvailability(startTime), 500);
    } else {
      // Do something if data is still not available after 10 seconds
      const loader = document.querySelector('.account-overview-widget__loader');
      if (loader) {
        loader.innerHTML = '<p>It is taking us longer than expected to fetch your account data. Please try refreshing the page.</p>';
      }
    }
  } else {
    initialiseAccountOverviewWidget();
  }
}

function initialiseAccountOverviewWidget() {
  populateAccountSelection();
  // Check local storage for accountBalancePaymentTypeKey
  const accountBalancePaymentTypeKey = localStorage.getItem('accountBalancePaymentTypeKey');
  // Get default job id which is available on invoices and statements pages
  const selectedJobId = document?.querySelector('#selected_job')?.value;
  // check if URL has filters parameter - checking for this later to see if the invoices / statements page is being loaded with a job id selected
  const filters = new URLSearchParams(window.location.search).get('filters');

  if (billingType) {
    if (selectedJobId && filters === '{}') { // need to make the selection here based on the default job id if we are coming to the invoices or statements pages without preselected job
      document.querySelector(`.account-summary-select [data-key="${selectedJobId}"]`).selected = true;
      document.querySelector('.account-summary-select').dispatchEvent(new Event('change'));
    } else if (accountBalancePaymentTypeKey !== 'AccountSummary' && accountBalancePaymentTypeKey !== null) { // this is for when there is no selected job id, e.g. on the account overview page
      document.querySelector(`.account-summary-select [data-key="${accountBalancePaymentTypeKey}"]`).selected = true;
      document.querySelector('.account-summary-select').dispatchEvent(new Event('change'));
    } else { // this is catch all just render the account summary
      updateAccountOverviewWidget('AccountSummary');
    }
  } else {
    updateAccountOverviewWidget('AccountSummary');
  }

  let isSyncingBalanceSelects = false; // Flag to prevent infinite loop for account-balance-select

  document.querySelectorAll('.account-balance-select').forEach((select) => {
    select.addEventListener('change', function () {
      if (isSyncingBalanceSelects) return; // Prevent infinite loop

      isSyncingBalanceSelects = true; // Set the flag to prevent triggering the other event listener

      const selectedValue = this.value;
      document.querySelectorAll('.account-balance-select').forEach((otherSelect) => {
        if (otherSelect !== this) {
          otherSelect.value = selectedValue;
          otherSelect.dispatchEvent(new Event('change')); // Trigger change event
        }
      });

      isSyncingBalanceSelects = false; // Reset the flag after synchronization
    });
  });

  // reset selects based on local storage as the local storage defaults to outstanding amount when coming back to the page from payment screen
  const accountBalancePaymentType = localStorage.getItem('accountBalancePaymentType');
  if (accountBalancePaymentType) {
    const accountBalanceSelect = document.querySelector('.account-balance-select');
    if (accountBalanceSelect) {
      accountBalanceSelect.value = accountBalancePaymentType;
      accountBalanceSelect.dispatchEvent(new Event('change'));
    }
  }

  // Synchronize account-summary-select dropdowns
  document.querySelectorAll('.account-summary-select').forEach((select) => {
    select.addEventListener('change', function () {
      const selectedValue = this.value;
      document.querySelectorAll('.account-summary-select').forEach((otherSelect) => {
        if (otherSelect !== this) {
          otherSelect.value = selectedValue;
          if (otherSelect.closest('.account-selection')) {
            otherSelect.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  });

  // Synchronize elements with class custom_amount_value if their IDs match
  document.querySelectorAll('input[name="custom_amount_value"]').forEach((input) => {
    input.addEventListener('input', function () {
      const inputName = this.name;
      document.querySelectorAll(`input[name="${inputName}"]`).forEach((otherInput) => {
        if (otherInput !== this) {
          otherInput.value = this.value;
        }
      });
    });
  });

  // Synchronize account select in widget and account filtering in table
  const query = document.querySelectorAll('.ex-invoices, .ex-statements');
  if (query.length) {
    const accountSummarySelect = document.querySelector('.account-summary-select');
    const gridInputSelectFilter = document.querySelector('.grid-input-select-filter select');

    let isSyncing = false; // Flag to prevent infinite loop

    const syncSelects = (sourceSelect, targetSelect, sourceAttribute, targetAttribute) => {
      if (!sourceSelect || !targetSelect) {
        return;
      }

      const selectedValue = sourceSelect.options[sourceSelect.selectedIndex]?.getAttribute(sourceAttribute);

      isSyncing = true; // Set the flag to prevent triggering the other event listener

      Array.from(targetSelect.options).forEach((option) => {
        if (option.getAttribute(targetAttribute) === selectedValue) {
          targetSelect.value = option.value;
          localStorage.setItem('accountBalancePaymentTypeKey', selectedValue); // Update local storage
          targetSelect.dispatchEvent(new Event('change')); // Trigger change event
        }
      });

      isSyncing = false; // Reset the flag after synchronization
    };

    // Initial synchronization when the page loads
    // Make the table load with the first account selected in the widget
    syncSelects(accountSummarySelect, gridInputSelectFilter, 'data-key', 'value');

    accountSummarySelect.addEventListener('change', () => {
      if (!isSyncing) {
        syncSelects(accountSummarySelect, gridInputSelectFilter, 'data-key', 'value');
      }
    });

    gridInputSelectFilter.addEventListener('change', () => {
      if (!isSyncing) {
        syncSelects(gridInputSelectFilter, accountSummarySelect, 'value', 'data-key');
      }
    });
  }
}

$(document).ready(() => {
  if (!isAccountOverview) return;

  document.querySelector('.page-content').insertAdjacentElement('afterbegin', createAccountOverviewWidget());

  if (dataAvailable) {
    initialiseAccountOverviewWidget();
  } else {
    getData();
    checkDataAvailability(Date.now());
  }
});
